import Datepicker from '@vuepic/vue-datepicker';
import { formatDateToUtc } from '@/core/helpers/date-format';
import { computed, defineComponent } from 'vue';
export default defineComponent({
    components: {
        Datepicker
    },
    props: {
        modelValue: String
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const SEPARATTOR = ',';
        const value = computed({
            get() {
                if (props.modelValue) {
                    const first = props.modelValue.split(SEPARATTOR)[0];
                    const second = props.modelValue.split(SEPARATTOR)[1];
                    return [first, second];
                }
                return [];
            },
            set(value) {
                let result = '';
                if (value.length === 2) {
                    value[0] = formatDateToUtc(value[0]);
                    value[1] = formatDateToUtc(value[1]);
                    result = value.join(SEPARATTOR);
                }
                emit('update:modelValue', result);
            }
        });
        return { value };
    }
});
